<app-title-header [title]="'title.need_help.title' | translate">
    <div class="actions-container d-flex flex-column flex-md-row align-items-center justify-content-between gap-2">

        <div class="w-100 w-md-auto">
            <app-global-search></app-global-search>
        </div>

        <button type="button" class="create-btn d-flex align-items-center justify-content-center w-100 w-md-auto" (click)="openCreateCasePopup()">
            <div>{{ 'buttons.create_new_case' | translate }} </div>
            <i class="bi bi-chevron-down"></i>
        </button>
    </div>
</app-title-header>

<div class="help-image-container">
    <img src="assets/img/help.png">
</div>

<app-need-help-form [form]="form" [isAdmin]="isAdmin"></app-need-help-form>

<app-help-document-library [isAdmin]="isAdmin"></app-help-document-library>

<app-team-management-form [isAdmin]="isAdmin"></app-team-management-form>
